import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { dateEs } from "@/lib/formatters";
import { Plus, Search, ClipboardList, FileImage } from "lucide-react";

export default function ReportsList() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/reports", { params: q ? { q } : {} });
      setItems(r.data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="p-4 sm:p-8 max-w-7xl mx-auto space-y-6" data-testid="reports-list-page">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-[11px] font-black tracking-[0.24em] uppercase text-[#005A91]">Módulo</div>
          <h1 className="text-3xl lg:text-4xl font-black text-[#0A1118] tracking-tight">Reportes de servicio</h1>
          <p className="text-slate-500 text-sm mt-1">Bitácora fotográfica con firma digital</p>
        </div>
        <Button onClick={() => nav("/reports/new")} data-testid="new-report-btn" className="bg-[#2E75B5] hover:bg-[#3a88cd] h-11 px-5 font-bold text-white">
          <Plus className="h-4 w-4 mr-2" /> Nuevo reporte
        </Button>
      </div>

      <div className="pe-card p-6">
        <div className="relative max-w-md">
          <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input data-testid="reports-search-input" placeholder="Buscar folio, título, cliente…"
                  value={q} onChange={(e) => setQ(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && load()}
                  className="h-11 pl-9 border-[#005A91]/20" />
        </div>
      </div>

      <div className="pe-card overflow-x-auto">
        {loading ? (
          <div className="text-center py-10 text-slate-500">Cargando…</div>
        ) : items.length === 0 ? (
          <div className="text-center py-16 text-slate-500" data-testid="reports-empty">
            <ClipboardList className="h-12 w-12 mx-auto text-slate-300 mb-3" />
            <div className="font-semibold">Sin reportes aún</div>
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] font-black uppercase tracking-wider text-slate-500 border-b border-[#005A91]/10">
                <th className="py-2.5 pr-3">Folio</th>
                <th className="py-2.5 pr-3">Título</th>
                <th className="py-2.5 pr-3">Cliente</th>
                <th className="py-2.5 pr-3">Fotos</th>
                <th className="py-2.5 pr-3">Estado</th>
                <th className="py-2.5 pr-3">Firma cliente</th>
                <th className="py-2.5 pr-3">Fecha</th>
              </tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.id} data-testid={`report-row-${r.folio}`} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="py-3 pr-3"><Link to={`/reports/${r.id}`} className="text-[#005A91] font-bold font-numbers hover:underline">{r.folio}</Link></td>
                  <td className="py-3 pr-3">{r.title || "—"}</td>
                  <td className="py-3 pr-3">{r.client?.name}</td>
                  <td className="py-3 pr-3 text-slate-500 font-numbers">
                    <span className="inline-flex items-center gap-1"><FileImage className="h-3.5 w-3.5" /> {(r.photos?.length ?? 0)}</span>
                  </td>
                  <td className="py-3 pr-3">
                    <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded border ${r.status === "cerrado" ? "bg-emerald-50 text-emerald-700 border-emerald-300" : "bg-slate-100 text-slate-600 border-slate-300"}`}>
                      {r.status === "cerrado" ? "Cerrado" : "Borrador"}
                    </span>
                  </td>
                  <td className="py-3 pr-3">{r.client_signature ? <span className="text-emerald-600 text-xs">✓ Firmado</span> : <span className="text-slate-400 text-xs">Pendiente</span>}</td>
                  <td className="py-3 pr-3 text-slate-500 text-xs">{dateEs(r.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
